export default __webpack_public_path__ + "static/media/jwt.2fa9cada.png";